"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRepeatDonorTipExperimentName = exports.getRepeatDonorTipExperimentName = exports.REPEAT_DONOR_TIP_EXPERIMENT_NAMES = exports.REPEAT_DONOR_LOW_TIP_OVER_250_EXPERIMENT_NAME = exports.REPEAT_DONOR_TIPPED_UI_EXPERIMENT_NAME = exports.REPEAT_DONOR_TIP_EXPERIMENT_HIGH_AMOUNT_THRESHOLD_IN_CENTS = void 0;
const feature_flags_1 = require("../enums/feature-flags");
exports.REPEAT_DONOR_TIP_EXPERIMENT_HIGH_AMOUNT_THRESHOLD_IN_CENTS = 25_000;
exports.REPEAT_DONOR_TIPPED_UI_EXPERIMENT_NAME = feature_flags_1.FeatureFlagName.RepeatDonorTippedLastDonationUiV1;
exports.REPEAT_DONOR_LOW_TIP_OVER_250_EXPERIMENT_NAME = feature_flags_1.FeatureFlagName.RepeatDonorLowTipOver250V1;
exports.REPEAT_DONOR_TIP_EXPERIMENT_NAMES = [
    feature_flags_1.FeatureFlagName.RepeatDonorZeroTipLowSuggestionsV4Under250,
    feature_flags_1.FeatureFlagName.RepeatDonorZeroTipLowSuggestionsV4Over250,
    exports.REPEAT_DONOR_TIPPED_UI_EXPERIMENT_NAME,
    exports.REPEAT_DONOR_LOW_TIP_OVER_250_EXPERIMENT_NAME,
];
const getRepeatDonorTipExperimentName = (amountInCents) => amountInCents < exports.REPEAT_DONOR_TIP_EXPERIMENT_HIGH_AMOUNT_THRESHOLD_IN_CENTS
    ? feature_flags_1.FeatureFlagName.RepeatDonorZeroTipLowSuggestionsV4Under250
    : feature_flags_1.FeatureFlagName.RepeatDonorZeroTipLowSuggestionsV4Over250;
exports.getRepeatDonorTipExperimentName = getRepeatDonorTipExperimentName;
const isRepeatDonorTipExperimentName = (name) => exports.REPEAT_DONOR_TIP_EXPERIMENT_NAMES.some((experimentName) => experimentName === name);
exports.isRepeatDonorTipExperimentName = isRepeatDonorTipExperimentName;
